module.exports = __webpack_public_path__ + "img/Jump Casting109.4f9df811.jpg";